import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteRounded from '@mui/icons-material/DeleteRounded';
import { Button } from '@mui/material';

export const FOLLOW_UP_DELETE_BUTTON = 'follow-up-delete-button';
export interface FollowUpDetailDeleteButtonProps {
  onClick: () => void;
  isDisabled: boolean;
}

const FollowUpDeleteButton: FC<FollowUpDetailDeleteButtonProps> = ({
  onClick,
  isDisabled,
}) => {
  const { t } = useTranslation('myFollowUp');

  return (
    <Button
      variant="cta"
      color="secondary"
      fullWidth
      startIcon={<DeleteRounded />}
      data-test-id={FOLLOW_UP_DELETE_BUTTON}
      onClick={onClick}
      disabled={isDisabled}
    >
      <span>{t('delete')}</span>
    </Button>
  );
};

export default FollowUpDeleteButton;
